import { render } from "./deactivated.vue?vue&type=template&id=191a2866"
import script from "./deactivated.vue?vue&type=script&lang=js"
export * from "./deactivated.vue?vue&type=script&lang=js"

import "./deactivated.vue?vue&type=style&index=0&id=191a2866&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__